export interface CameraSize {
  width: number;
  height: number;
}

export enum DistanceStatus {
  OK,
  NEAR,
  FAR,
}

export interface Dimension {
  x: number;
  y: number;
}

export interface EvaluateFace {
  centered: boolean;
  distanceStatus: DistanceStatus;
  headStraight: boolean;
  smoothedRelativeFaceHeight: number;
  ratio: number;
  interEye: number;
  faceHeight: number;
  angle: number;
}
